<template>
  <v-card class="px-3 py-3">
    <div class="text-center"><h2>Chi tiết khuyến mại {{campaign.promotionCode}}</h2></div>
    <div
      class="box-coupon-detail pa-2"
      style="
        max-height: 550px;
        border-radius: 10px;
        overflow-y: auto;
        overflow-x: hidden;
      "
    >
      <span v-if="!campaign" style="font-style: italic; color: #787879"
        >Không có thông tin về khuyến mại</span
      >
      <div v-else>
        <v-row>
          <v-col class="pl-6">
            <h4>Tên chiến dịch</h4>
            <span>{{ campaign.title }}</span>
            <h4>Mô tả</h4>
            <span>{{ campaign.description ? campaign.description : "--" }}</span>
            <h4 class="mt-2">Loại chiến dịch</h4>
            <span style="text-transform: uppercase">{{ campaignType }}</span>
            <div v-if="campaign.type == 1">
              <h4 class="mt-2">Giá trị giảm</h4>
              <span>{{ formatCurrency(campaign.promotionDiscount) }}</span>
            </div>
            <div v-if="campaign.type == 2">
              <h4 class="mt-2">Giá trị giảm</h4>
              <span>{{ campaign.promotionDiscount }} (%)</span>
              <h4 v-if="campaign.numberOfAvailableOrder" class="mt-2">
                Giá trị giảm tối đa
              </h4>
              <span v-if="campaign.numberOfAvailableOrder">{{
                formatCurrency(campaign.numberOfAvailableOrder)
              }}</span>
            </div>
            <div v-if="campaign.type == 1 || campaign.type == 2">
              <h4 class="mt-2">Loại hình áp dụng</h4>
              <span>{{ application }}</span>
            </div>
            <h4 class="mt-2">Thời gian áp dụng</h4>
            <span v-if="campaign.endDate"
              >{{ campaign.startDate ? formatDateDMY2(campaign.startDate) : "_" }}
              -
              {{
                campaign.endDate
                  ? formatDateDMY2(campaign.endDate)
                  : "Không giới hạn"
              }}</span
            >
            <span v-else
              >Từ ngày
              {{
                campaign.startDate ? formatDateDMY2(campaign.startDate) : "_"
              }}</span
            >
            <h4 class="mt-2">Điều kiện áp dụng</h4>
            <span
              >Giá trị đơn hàng tối thiểu: {{ formatCurrency(getMin(campaign))
              }}<br
            /></span>
            <span
              >Loại sản phẩm: {{ typeOfProductObj[campaign.typeOfProduct] }}<br
            /></span>
            <div v-if="skus.length">
              <div>Danh sách sản phẩm áp dụng:</div>
              <ul class="pl-6">
                <li
                  v-for="(item, idx) in skus"
                  :key="idx"
                  style="list-style: disc"
                >
                  <div class="text-line-1">{{ item.skuName }}</div>
                </li>
              </ul>
            </div>
            <div
              v-if="
                campaign.promotionCampaignConditionDirect &&
                campaign.promotionCampaignConditionDirect.categoryList &&
                campaign.promotionCampaignConditionDirect.categoryList.length
              "
            >
              <div>Danh mục được áp dụng:</div>
              <ul class="pl-6">
                <li
                  v-for="(item, idx) in campaign.promotionCampaignConditionDirect
                    .categoryList"
                  :key="idx"
                  style="list-style: disc"
                >
                  <div class="text-line-1">
                    {{ item.fullLevelName.join(" > ") }}
                  </div>
                </li>
              </ul>
            </div>
            <div v-if="gifts.length">
              <div>Thông tin sản phẩm tặng:</div>
              <ul class="pl-6">
                <li style="list-style: disc">
                  <div>
                    <span>{{ sku.name }}.</span>
                    <span v-if="gifts && gifts.length">{{
                      gifts.length === 1
                        ? "Tặng"
                        : `Tặng 1 trong ${gifts.length} sản phẩm tuỳ chọn`
                    }}</span
                    >:
                  </div>
                  <div v-for="(item) in gifts" :key="item.productCode">
                    <div
                      class="d-flex my-2"
                      style="align-items: flex-start"
                    >
                      <div style="font-size: 1rem" class="pl-3"
                        ><span style="font-weight: bold">{{
                          item.quantity
                        }}</span>
                        x {{ item.skuName }}</div
                      >
                    </div>
                  </div>
                </li>
                <li
                  v-for="(item, oid) in otherSkus"
                  :key="item.purchasedProductCode"
                >
                  <span>{{ getSkuName(item.purchasedProductCode) }}</span>
                  <br />
                  Nhận:
                  <br />
                  <div
                    v-for="(entry, gid) in item.giftProducts"
                    :key="gid"
                    class="d-flex"
                  >
                    <div style="width: 19px; height: 19px" />
                    <label class="pl-2"
                      ><span style="font-weight: bold">{{
                        entry.quantity
                      }}</span>
                      x {{ entry.skuName }}</label
                    >
                  </div>
                  <div v-if="oid < otherSkus.length - 1" class="pl-2">hoặc</div>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-card>
</template>

<script>
import { CampaignType, getCampaignType } from "@/helpers/campaign";

export default {
  props: {
    campaign: {
      type: Object,
      default: () => ({}),
    },
    tutorSkus: {
      type: Array,
      default: () => []
    },
    productSelected: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      typeOfProductObj: {
        1: "Mua mới",
        2: "Gia hạn",
        3: "Mua mới và Gia hạn",
      },
      sku: null,
      product: null,
    };
  },
  async mounted() {
    await this.open(this.productSelected)
  },
  computed: {
    application() {
      let type = this.campaign?.typeOfApplication;
      if (type == 1) return 'Theo đơn hàng';
      if (type == 2) return 'Theo sản phẩm (SKU)';
      if (type == 3) return 'Theo danh mục';
      return 'Khác';
    },
    skus() {
      // if (this.campaign?.type != CampaignType.DIRECT) return [];
      return this.campaign.promotionCampaignConditionDirect?.skus || [];
    },
    otherSkus() {
      return [];
      const code = this.sku?.code;
      if (this.campaign?.type != CampaignType.XY) return [];
      let items = this.campaign.promotionCampaignConditionGiftByAmount?.giftProductsByBoughtProducts || [];
      return items.filter(it => code != it.purchasedProductCode);
    },
    campaignType() {
      if (!this.campaign) return '';
      let type = getCampaignType(this.campaign.type);
      return type?.name || '';
    },
    gifts() {
      const code = this.sku?.code;
      if (this.campaign?.type != CampaignType.XY) return [];
      let items = this.campaign.promotionCampaignConditionGiftByAmount?.giftProductsByBoughtProducts || [];
      let item = items.find(it => it.purchasedProductCode == code);
      if (!item) return [];
      return item.giftProducts || [];
    },
  },
  methods: {
    getMin(c) {
      if (c.type == CampaignType.DIRECT || c.type == CampaignType.PERCENT)
        return c.promotionCampaignConditionDirect?.minimumAmount || 0;
      if (c.type == CampaignType.XY)
        return c.promotionCampaignConditionGiftByAmount?.minimumAmount || 0;
      if (c.type == CampaignType.GIFT)
        return c.promotionCampaignConditionGiftByProduct?.minimumAmount || 0;
      return 0;
    },
    getSkuName(code) {
      if (this.tutorSkus?.length < 0) return '';
      let sku = this.tutorSkus.find(it => it.code == code);
      return sku?.name || '';
    },
    async open(product) {
      if (!product?.productId) return;
      const skus = product.products || [];
      const sku = skus.find(item => item.id == product.productId);
      if (!sku?.code) return;
      this.product = product;
      this.sku = sku;
    }
  },
};
</script>

<style>
</style>